import { instantiateAuth0Client } from "@jana-technology/platform-ui";

export const auth0Client = instantiateAuth0Client({
  domain: import.meta.env.AUTH0_DOMAIN as string,
  clientId: import.meta.env.AUTH0_CLIENT_ID as string,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.AUTH0_AUDIENCE as string,
  },
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
});

export default auth0Client;
